import RenderInputOption from '../inputs/RenderInputOption';
import RenderTrackOption from '../inputs/RenderTrackOption';
import '../css/table.css';
import { useNavigation } from '../function/navigation';
import { UnitConversion } from '../inputs/UnitConversion';

function TrackPage({
  inputs,
  setInputs,
  result,
  options,
  setOptions,
  inputFields,
}) {
  const { nav } = useNavigation();
  const unitSystem = inputs.unit_system;
  const visibleInputFields = inputFields.filter((field) =>
    options.some((option) => option.field === field)
  );

  const shouldHide =
    visibleInputFields.every((field) => {
      const option = options.find((o) => o.field === field);
      return option?.options?.length === 1;
    }) && nav.showOptions !== 'all';

  if (shouldHide) return null;

  const lengthUnit = UnitConversion(null, unitSystem, 'm').displayedUnit;
  const widthUnit = UnitConversion(null, unitSystem, 'mm').displayedUnit;

  return (
    <>
      <RenderInputOption
        inputs={inputs}
        setInputs={setInputs}
        options={options}
        setOptions={setOptions}
        input_name="track"
        result={result}
        forceShowAll
      />

      <div className="glass track-table-container">
        <table>
          <thead>
            <tr>
              <th>Track number</th>
              <th>Track width [{widthUnit}]</th>

              {visibleInputFields.map((field) => (
                <th key={field}>
                  {options.find((o) => o.field === field)?.name}
                </th>
              ))}

              <th>Length [{lengthUnit}]</th>
            </tr>
          </thead>

          <tbody>
            {Object.keys(inputs.track || {}).map((trackNumber) => {
              const rawWidth = inputs.track[trackNumber];
              const rawLength = result.track_length?.[trackNumber];

              const { displayedValue: widthDisplay } = UnitConversion(
                rawWidth,
                unitSystem,
                'mm'
              );
              const { displayedValue: lengthDisplay } = UnitConversion(
                rawLength / 1000,
                unitSystem,
                'm'
              );

              return (
                <tr key={trackNumber}>
                  <td className="table-value">{trackNumber}</td>

                  <td className="table-value">
                    {(() => {
                      const num =
                        typeof widthDisplay === 'number'
                          ? widthDisplay
                          : typeof widthDisplay === 'string' &&
                              widthDisplay.trim() !== ''
                            ? Number(widthDisplay)
                            : NaN;

                      return Number.isFinite(num)
                        ? Math.round(num * 100) / 100
                        : '';
                    })()}
                  </td>

                  {visibleInputFields.map((field) => (
                    <RenderTrackOption
                      key={`${field}_${trackNumber}`}
                      inputs={inputs}
                      setInputs={setInputs}
                      options={options}
                      setOptions={setOptions}
                      input_name={field}
                      index={trackNumber}
                    />
                  ))}

                  <td className="table-value">
                    {typeof lengthDisplay === 'number'
                      ? Math.round(lengthDisplay * 100) / 100
                      : ''}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TrackPage;
